import { CombinedListSort, GetSortNumberForPlace } from './common/sorting';
import { Class, Favourite, IntermediatePoint, Message, PageSettings, RaceInfo, Runner, Time, START_CODE, FINISH_CODE, COMBINED_CODE, RunnerStatus, RelayTeamsStarttime, ResultLookup, Language, NewChanges } from './common/types';
import { HandleChangesNew } from './common/changes'
import { EscapeHtml, FormatMilliseconds, FormatCombinedPlaceAndTime, FormatPlace, FormatShooting } from './common/render';
import { NewWebsocket } from './common/mywebsocket'
import { CalculateRunningTime, CreateResultLookup } from './common/running_time';
import { EnsureAllIntermediatePointsArePresent, IsNullOrWhitespace } from './common/utilities';

import { GetInitialLanguage, UpdateLanguage } from './common/i18n';
import { StartPingTimer } from './common/ping';
import { Column, ColumnTypeEnum, ConfigType, ErikTable, ForEachFilter, RenderTypeEnum, SortDirection, TableSortType } from './common/table';
import { FormatDate } from './common/datetime';

const ALL_LEGS: number = -1;
const LEFT_MENU_CLASSES = 'classes';
const LEFT_MENU_CLUBS = 'clubs';
const LEFT_MENU_FAVOURITES = 'favourites';
let leftMenu: string = LEFT_MENU_CLASSES;

const urlParams = new URLSearchParams(window.location.search)
const raceId: string = urlParams.get('id');
const autoScrollInterval: number = Number.parseInt(urlParams.get('autoscroll'));

var webSocket: NewWebsocket = null;

var datatables: { mainTable: ErikTable<number, Runner>, sprintTables: ErikTable<number, Runner>[] } = {
    mainTable: null,
    sprintTables: []
};

let sprintColumnDefsForClass = new Map<string, Column<Runner>[]>();

let race: RaceInfo = null;
let classes: Class[] = [];
let intermediatePoints: IntermediatePoint[] = [];
let intermediatePointsPerClass = new Map<string, IntermediatePoint[]>();
let messages: Message[] = [];

let selectedGroupId: string = null;
let selectedIntermediatePoint: string = null;
let selectedLegNumber: number = null;
let selectedGroupIsSprint: boolean = false;

let columns: Column<Runner>[] = [];
let firstIntermediateColumnIndex: number = -1;
let lastIntermediateColumnIndex: number = -1;

let firstLoad: boolean = true;

let currentLanguage: Language = GetInitialLanguage();

function StartLeftMenuAutoScroll(intervalInSeconds: number) {
    setInterval(function () {
        const leftMenu = document.getElementById('classes-children');

        // Do we scroll to the next page first?
        let currentPageIndex = datatables.mainTable.CurrentPageIndex();
        if (datatables.mainTable.NumPages() > currentPageIndex + 1) {
            datatables.mainTable.SetCurrentPageIndex(currentPageIndex + 1);
            datatables.mainTable.newDraw();
            return;
        }

        let selectNextGroup = false;
        for (const menuItemRaw of leftMenu.children) {
            const menuItem = menuItemRaw as HTMLDivElement;

            // We do not want to automatically select "Alle klasser".
            if (selectNextGroup && menuItem.dataset.allClasses == '0') {
                selectedGroupId = menuItem.dataset.classId;
                selectNextGroup = false;
                break;
            }

            if (ClassNameContainsClass(menuItem.className, 'selected')) {
                selectNextGroup = true;
            }
        }

        if (selectNextGroup) {
            const firstMenuItem = leftMenu.children[0] as HTMLDivElement;
            selectedGroupId = firstMenuItem.dataset.classId;
        }

        SelectedGroupChanged();
    }, intervalInSeconds * 1000);
}

window.onload = function () {
    const leftMenuClassesButton = document.getElementById('left-menu-classes');
    leftMenuClassesButton.onclick = SetLeftMenuClasses;

    const leftMenuClubsButton = document.getElementById('left-menu-clubs');
    leftMenuClubsButton.onclick = SetLeftMenuClubs;

    const leftMenuFavouritesButton = document.getElementById('left-menu-favourites');
    leftMenuFavouritesButton.onclick = SetLeftMenuFavourites;

    const exportExcelButton = document.getElementById('export-excel-button');
    exportExcelButton.onclick = ExportExcel;

    ReCreateDataTable();

    StartListeners();

    CalculateRunningTimeTimer();

    if (!Number.isNaN(autoScrollInterval) && autoScrollInterval > 0) {
        StartLeftMenuAutoScroll(autoScrollInterval);
    }

    (document.getElementById('language-en-us') as HTMLImageElement).onclick = function () {
        currentLanguage = UpdateLanguage('en-US', false);
        ReCreateDataTable();
        PrintTableHeading();
        PrintIntermediatePoints();
    };

    (document.getElementById('language-nb-no') as HTMLImageElement).onclick = function () {
        currentLanguage = UpdateLanguage('nb-NO', false);
        ReCreateDataTable();
        PrintTableHeading();
        PrintIntermediatePoints();
    };

    (document.getElementById('decrease-font-size') as HTMLDivElement).onclick = function () {
        DecreaseFontSize();
    };

    (document.getElementById('increase-font-size') as HTMLDivElement).onclick = function () {
        IncreaseFontSize();
    };

    currentLanguage = UpdateLanguage(currentLanguage.code, true);

    const storedFontSize = localStorage.getItem('fontsize');
    if (storedFontSize !== null) {
        SetFontSize(Number.parseFloat(storedFontSize));
    }

    StartPingTimer('race.html?id=' + raceId, function () {
        return {
            'fontsize': localStorage.getItem('fontsize'),
            'language': currentLanguage.code
        };
    });
};


function GetFontSize(element: HTMLElement): number {
    if (element.style.fontSize == '') {
        return 1.0;
    }

    return Number.parseFloat(element.style.fontSize.substring(0, element.style.fontSize.length - 2));
}

function IncreaseFontSize(): void {
    const body = document.getElementsByTagName('body')[0] as HTMLBodyElement;
    SetFontSize(GetFontSize(body) * 1.1);
}

function DecreaseFontSize(): void {
    const body = document.getElementsByTagName('body')[0] as HTMLBodyElement;
    SetFontSize(GetFontSize(body) / 1.1);
}

function SetFontSize(size: number): void {
    const body = document.getElementsByTagName('body')[0] as HTMLBodyElement;
    body.style.fontSize = size.toFixed(2) + 'em';
    localStorage.setItem('fontsize', size.toString());
}

function RaceHasTag(tagName: string): boolean {
    if (race.tags == null) {
        return false;
    }

    for (const tag of race.tags) {
        if (tag === tagName) {
            return true;
        }
    }

    return false;
}

function IsRidderuka(): boolean {
    return RaceHasTag("ridderuka");
}

function ShowShootings(): boolean {
    if (leftMenu === LEFT_MENU_CLASSES && selectedGroupId !== null) {
        return NumShootingsInClass(GetClass(selectedGroupId)) > 0;
    }

    return MaxNumShootings() > 0;
}

function ShowNormalPlaceAndTime(): boolean {
    if (selectedIntermediatePoint == START_CODE || selectedIntermediatePoint == COMBINED_CODE) {
        return false;
    }

    return true;
}

function ShowStarttime(): boolean {
    if (selectedIntermediatePoint == START_CODE || selectedIntermediatePoint == COMBINED_CODE) {
        return true;
    }

    return false;
}

function ShowTimingChips(): boolean {
    return selectedIntermediatePoint == START_CODE;
}

function ShowCombinedPlaceAndTime(): boolean {
    return selectedIntermediatePoint == COMBINED_CODE;
}


function GetTableSort(): TableSortType[] {
    let showPlace = true;
    if (selectedGroupId !== null && leftMenu === LEFT_MENU_CLASSES) {
        let selectedClass = GetClass(selectedGroupId);
        if (selectedClass !== null && ('show_place' in selectedClass)) {
            showPlace = selectedClass.show_place;
        }
    }

    let order: TableSortType[] = [];
    if (selectedIntermediatePoint === START_CODE) {
        order.push({
            column_idx: GetColumnIndex('starttime'),
            sort_direction: SortDirection.Ascending
        });
    } else if (selectedIntermediatePoint === COMBINED_CODE) {
        if (showPlace && leftMenu === LEFT_MENU_CLASSES) {
            let sortOrder = SortDirection.Ascending;
            if (selectedGroupId === null) {
                sortOrder = SortDirection.Descending;
            }
            order.push({
                column_idx: GetColumnIndex('finish'),
                sort_direction: sortOrder
            });

            for (let i = lastIntermediateColumnIndex; i >= firstIntermediateColumnIndex; --i) {
                order.push({
                    column_idx: i,
                    sort_direction: sortOrder
                });
            }

        }

        order.push({ column_idx: GetColumnIndex('starttime'), sort_direction: SortDirection.Ascending });
    } else {
        if (leftMenu === LEFT_MENU_CLASSES) {
            if (selectedGroupId === null) {
                order.push({ column_idx: GetColumnIndex('passing_time'), sort_direction: SortDirection.Descending });
            } else {
                if (showPlace) {
                    order.push({ column_idx: GetColumnIndex('place'), sort_direction: SortDirection.Ascending });
                }
            }
        }
    }

    // Do a final sort on bib, name and runner_id to ensure stable sorting.
    order.push({ column_idx: GetColumnIndex('bib'), sort_direction: SortDirection.Ascending });
    order.push({ column_idx: GetColumnIndex('name'), sort_direction: SortDirection.Ascending });
    // order.push({ column_idx: GetColumnIndex('runner_id'), sort_direction: SortDirection.Ascending });

    return order;
}

function FindMostUsedSortOrderForCode(code: string) {
    let orderCounts = {};
    for (const point of intermediatePoints) {
        if (point.code === code) {
            if (point.sort_order in orderCounts) {
                orderCounts[point.sort_order]++;
            } else {
                orderCounts[point.sort_order] = 1;
            }
        }
    }

    let arr = [];
    for (const key in orderCounts) {
        arr.push({
            'sort_order': key,
            'count': orderCounts[key]
        });
    }

    arr.sort((a, b) => { return b.count - a.count; });
    return Number.parseInt(arr[0].sort_order);
}

function NameRender(data: any, row: Runner, type: RenderTypeEnum): string {
    let out = '';

    if (row.family_name === null && row.given_name === null) {
        // Do no more
    } else if (row.family_name === null || row.family_name.trim().length === 0) {
        out = out + row.given_name;
    } else if (row.given_name === null || row.given_name.trim().length === 0) {
        out = out + row.family_name;
    } else {
        out = out + row.family_name + ', ' + row.given_name;
    }

    if (type == RenderTypeEnum.Sort) {
        return out;
    }

    if (row.favourite) {
        return '&starf;' + EscapeHtml(out);
    }

    if (out.length == 0) {
        return "&nbsp;";
    }
    return EscapeHtml(out);
}

function CreateColumns(): void {
    const isRelay = selectedLegNumber !== null || (AllClassesOrClubOrFavouritesIsSelected() && AnyClassIsRelay());
    let isPursuit = AllClassesOrClubOrFavouritesIsSelected() && AnyClassIsPursuit();
    if (selectedGroupId !== null && leftMenu === LEFT_MENU_CLASSES) {
        let selectedClass = GetClass(selectedGroupId);
        isPursuit = ClassIsPursuit(selectedClass);
    }

    columns = [];

    if (ShowNormalPlaceAndTime()) {
        columns.push({
            'data': null,
            'title': currentLanguage.race_place,
            'cssStyle': ['align-right'],
            'render': PlaceRender,
            'name': 'place',
            'sortType': ColumnTypeEnum.Number
        });
    }

    columns.push({
        'data': null,
        'name': 'bib',
        'title': currentLanguage.race_bib,
        'cssStyle': ['align-right'],
        'sortType': ColumnTypeEnum.Number,
        'render': BibNumberRender
    });

    if (ShowAllLegs()) {
        columns.push({
            'data': 'leg_number',
            'name': 'leg_number',
            'title': currentLanguage.race_leg,
            'cssStyle': ['align-right']
        });
    }

    if (isRelay) {
        columns.push(
            {
                'data': 'relay_team',
                'name': 'relay_team',
                'title': currentLanguage.race_team,
                'render': EscapeHtml,
                'cssStyle': ['clickable-div']
            });
    }


    columns.push({
        'data': null,
        'title': currentLanguage.race_name,
        'name': 'name',
        'cssStyle': ['clickable-div'],
        'render': NameRender
    });


    if (AllClassesOrClubOrFavouritesIsSelected()) {
        columns.push({
            'data': 'class_name',
            'title': currentLanguage.race_class_name,
            'name': 'class_name',
            'cssStyle': ['clickable-table-cell'],
            'render': EscapeHtml
        });
    }

    if (leftMenu !== LEFT_MENU_CLUBS) {
        columns.push(
            {
                'data': 'club_name',
                'title': currentLanguage.race_club_name,
                'name': 'club_name',
                'render': EscapeHtml,
                'cssStyle': ['clickable-table-cell']
            });
    }

    if (!ShowCombinedPlaceAndTime() && ShowStarttime()) {
        columns.push(
            {
                'data': null,
                'render': StarttimeRender,
                'title': currentLanguage.race_starttime,
                'cssStyle': ['align-right'],
                'name': 'starttime',
                'sortType': ColumnTypeEnum.Number
            });
    }

    if (ShowTimingChips()) {
        columns.push(
            {
                'data': 'timing_chips',
                'render': TimingChipsRender,
                'title': currentLanguage.race_chip_number,
                'cssStyle': ['align-right'],
                'sortType': ColumnTypeEnum.Number
            });
    }

    if (ShowNormalPlaceAndTime()) {
        columns.push(
            {
                'data': null,
                'title': currentLanguage.race_used_time,
                'cssStyle': ['align-right'],
                'render': UsedTimeRender,
                'name': 'used_time',
                'sortType': ColumnTypeEnum.Number
            });

        columns.push(
            {
                'data': null,
                'title': currentLanguage.race_difference,
                'cssStyle': ['align-right'],
                'render': DifferenceRender,
                'name': 'difference',
                'sortType': ColumnTypeEnum.Number
            });

        if (isRelay || isPursuit) {
            columns.push(
                {
                    'data': null,
                    'title': IsRidderuka() ? currentLanguage.race_used_time_leg_ridderuka : currentLanguage.race_used_time_leg,
                    'cssStyle': ['align-right'],
                    'render': UsedTimeLegRender,
                    'name': 'used_time_leg',
                    'sortType': ColumnTypeEnum.Number
                });
        }

        if (ShowShootings()) {
            columns.push(
                {
                    'data': null,
                    'title': currentLanguage.race_shootings,
                    'render': ShootingRender
                });
        }

        columns.push(
            {
                'data': null,
                'title': '',
                'cssStyle': ['align-right', 'small-table-text'],
                'render': PassingTimeRender,
                'name': 'passing_time',
                'sortType': ColumnTypeEnum.Number
            });
    }


    if (ShowCombinedPlaceAndTime()) {
        columns.push(
            {
                'data': null,
                'render': StarttimeRender,
                'title': currentLanguage.race_starttime,
                'cssStyle': ['align-right'],
                'name': 'starttime'
            });

        if (ShowShootings()) {
            columns.push(
                {
                    'data': null,
                    'title': currentLanguage.race_shootings,
                    'render': ShootingRender
                });
        }

        let points = GetIntermediatePointsForClassId(selectedGroupId, selectedLegNumber);

        if (AllClassesOrClubOrFavouritesIsSelected()) {
            points.sort((a, b) => {
                return FindMostUsedSortOrderForCode(a.code) - FindMostUsedSortOrderForCode(b.code);
            });
        } else {
            points.sort((a, b) => a.sort_order - b.sort_order);
        }
        firstIntermediateColumnIndex = columns.length;
        for (const point of points) {
            let columnHeader: string;
            if (AllClassesOrClubOrFavouritesIsSelected()) {
                columnHeader = point.code.toString();
            } else {
                columnHeader = point.text;
            }

            columns.push(CreateCombinedTimeAndPlaceColumnDefinition(point.code, columnHeader));
        }

        lastIntermediateColumnIndex = columns.length - 1;
    }


    if (ShowCombinedPlaceAndTime()) {
        columns.push(CreateCombinedTimeAndPlaceColumnDefinition('finish', currentLanguage.race_finish));
    }
    return null;
}

function BibNumberRender(data: any, row: Runner, type: RenderTypeEnum) {
    if (type == RenderTypeEnum.Sort) {
        return row.bib;
    }

    if (row.relay_team === null || row.relay_team.trim().length === 0) {
        return row.bib;
    }

    if (row.bib === null) {
        return '';
    }

    // Assume that the last two digits are leg number.
    const bibString = row.bib.toString();
    return bibString.substring(0, bibString.length - 2) + '-' + row.leg_number;
}

function InitializeSprintTables() {
    let columnsTemplate: Column<Runner>[] = [
        {
            'data': null,
            'title': currentLanguage.race_bib,
            'cssStyle': ['align-right'],
            'sortType': ColumnTypeEnum.Number,
            'render': BibNumberRender
        }, {
            'data': null,
            'title': currentLanguage.race_name,
            'render': NameRender
        }, {
            'data': null,
            'title': currentLanguage.race_used_time,
            'cssStyle': ['align-right'],
            'render': CombinedPlaceAndTimeRender,
            'name': 'finish',
            'sortType': ColumnTypeEnum.Number
        }
    ];

    let runners = datatables.mainTable.data();
    let tableElements = document.getElementById('sprint').getElementsByClassName('sprint-table');
    for (let table of tableElements) {
        const classId = (table as HTMLDivElement).dataset.classId;
        let newColumns: Column<Runner>[] = [];

        for (const col of columnsTemplate) {
            newColumns.push(col);
        }

        let points = GetIntermediatePointsForClassId(classId, null);
        points.sort((a, b) => a.sort_order - b.sort_order);

        for (const point of points) {
            const definition = CreateCombinedTimeAndPlaceColumnDefinition(point.code, point.text);
            newColumns.splice(newColumns.length - 1, 0, definition);
        }
        sprintColumnDefsForClass.set(classId, newColumns);

        let filter = function (runner: Runner): boolean {
            return runner.class_id == classId
        };

        let orderCols: TableSortType[] = [];
        for (let i = newColumns.length - 1; i > 1; --i) {
            orderCols.push({ column_idx: i, sort_direction: SortDirection.Ascending });
        }

        orderCols.push({ column_idx: 0, sort_direction: SortDirection.Ascending });


        let datatable = new ErikTable<number, Runner>(table as HTMLDivElement, {
            'columns': newColumns,
            'data': runners,
            'id': 'runner_id',
            'sort': orderCols,
            'filter': filter
        });

        datatables.sprintTables.push(datatable);
    }

    for (let table of datatables.sprintTables) {
        table.newDraw();
    }
}

function PrintSprint(): void {
    datatables.sprintTables = [];
    sprintColumnDefsForClass = new Map<string, Column<Runner>[]>();

    document.getElementById('sprint').innerHTML = '';
    const selectedClass = GetClass(selectedGroupId);

    const sprintRoundTemplate = document.getElementById('sprint-round-template') as HTMLDivElement;
    for (let i = 0; i < selectedClass.sprint_total_number_of_rounds; ++i) {
        let sprintRoundElement = sprintRoundTemplate.cloneNode(true) as HTMLDivElement;
        sprintRoundElement.hidden = false;

        CreateHtmlHeatsForRound(selectedClass, i, sprintRoundElement)
        document.getElementById('sprint').appendChild(sprintRoundElement);
    }

    InitializeSprintTables();
}

function CreateHtmlHeatsForRound(
    parentClass: Class, roundIndex: number, divToAppendTo: HTMLDivElement): void {
    const classIdPrefix = parentClass.class_id + "-" + roundIndex + "-";

    const sprintHeatTemplate = document.getElementById('sprint-heat-template') as HTMLDivElement;
    for (const classObj of classes) {
        if (classObj.class_id.startsWith(classIdPrefix)) {
            // Remove the parent class name, and uppercase the first character.
            let headerText = classObj.name.substring(parentClass.name.length).trim();
            headerText = headerText.charAt(0).toUpperCase() + headerText.substring(1);

            if (('first_start' in classObj) && classObj.first_start !== null) {
                headerText += ' - (' + FormatDate(new Date(classObj.first_start), 'HH:MM:SS') + ')';
            }

            let sprintHeatElement = sprintHeatTemplate.cloneNode(true) as HTMLDivElement;
            sprintHeatElement.hidden = false;
            (sprintHeatElement.getElementsByClassName('sprint-round-header')[0] as HTMLDivElement).innerText = headerText;
            (sprintHeatElement.getElementsByClassName('sprint-table')[0] as HTMLDivElement).dataset.classId = classObj.class_id;
            divToAppendTo.appendChild(sprintHeatElement);
        }
    }
}

function CellClicked(column: Column<Runner>, clickedRow: Runner): void {
    if (column.name == 'club_name') {
        selectedGroupId = clickedRow.club_name;
        SetLeftMenuClubs();
    } else if (column.name == 'class_name') {
        const classObj = GetClass(clickedRow.class_id);
        if (IsSprintClass(classObj)) {
            if (classObj.class_id.endsWith('-prolog')) {
                selectedGroupId = classObj.class_id;
            }
            else {
                selectedGroupId = classObj.parent_class_id;
            }
        } else {
            selectedGroupId = clickedRow.class_id;
        }
        SetLeftMenuClasses();
    } else if (column.name == 'name') {
        clickedRow.favourite = !clickedRow.favourite;
        SaveSettings();

        datatables.mainTable.newDraw();
        return;
    } else if (column.name == 'relay_team') {
        const newValue = !clickedRow.favourite;
        for (const row of datatables.mainTable.data()) {
            if (row.relay_team == clickedRow.relay_team && row.class_id == clickedRow.class_id) {
                row.favourite = newValue;
            }
        }
        datatables.mainTable.newDraw();

        SaveSettings();
    }

    SelectedGroupChanged();
}

function ReCreateDataTable(): void {
    if (selectedGroupIsSprint) {
        document.getElementById('tblContainer').classList.add('hidden');
        document.getElementById('intermediate-points').classList.add('hidden');
        document.getElementById('export-buttons').classList.add('hidden');

        document.getElementById('sprint').classList.remove('hidden');
        PrintSprint();
        return;
    }
    document.getElementById('sprint').classList.add('hidden');
    document.getElementById('intermediate-points').classList.remove('hidden');
    document.getElementById('export-buttons').classList.remove('hidden');

    let data = [];
    let previousPageLength = 50;
    const first = datatables.mainTable === null;
    if (datatables.mainTable !== null) {
        document.getElementById('tblContainer').classList.remove('hidden');
        data = datatables.mainTable.data();
        previousPageLength = datatables.mainTable.pageLength();
    }

    document.getElementById('runnerTable').innerHTML = '';

    CreateColumns();
    let config: ConfigType<Runner> = {
        'columns': columns,
        'id': 'runner_id',
        'cellClicked': CellClicked,
        'paging': [25, 50, 100, -1],
        'rowsPerPage': previousPageLength,
        'sort': GetTableSort(),
        'data': data,
        'conditionalRowStyling': function (row: Runner) {
            if (selectedIntermediatePoint === START_CODE ||
                selectedIntermediatePoint === COMBINED_CODE) {
                return []
            };

            if (IsTimeRecentEvent(row.times[selectedIntermediatePoint], recentRowLimit)) {
                return ['recent-event'];
            }

            return [];
        }
    };

    if (leftMenu == LEFT_MENU_FAVOURITES) {
        config.i18n = {
            emptyTable: currentLanguage.race_add_favourites
        };
    } else {
        config.i18n = {
            emptyTable: currentLanguage.race_no_runners
        };
    }

    datatables.mainTable = new ErikTable<number, Runner>('runnerTable', config);

    SetTableSearch();
    recentRowLimit = GetMarkRecentRowLimit();
    datatables.mainTable.newDraw();
    PrintRunnerStatistics();
}

function LoadSettings(): PageSettings {
    const str = localStorage.getItem(raceId);
    if (str == null) {
        return {
            'favourites': {}
        };
    }

    try {
        return JSON.parse(str) as PageSettings;
    } catch (ex) {
        return {
            'favourites': {}
        };
    }

}

function SaveSettings(): void {
    let settings = LoadSettings();
    settings.favourites = {} as Favourite;

    for (const runner of datatables.mainTable.data()) {
        if (runner.favourite) {
            settings.favourites[runner.runner_id] = true;
        }
    }

    localStorage.setItem(raceId, JSON.stringify(settings));
}

function SelectedIntermediatePointChanged() {
    let intermediateElements = document.getElementById('intermediate-points').children;
    for (let i = 0; i < intermediateElements.length; ++i) {
        let element = intermediateElements[i] as HTMLElement;
        if (element.dataset.code == selectedIntermediatePoint) {
            AddClass(element, 'selected');
        } else {
            RemoveClass(element, 'selected');
        }
    }

    ReCreateDataTable();
    PrintTableHeading();
}

function IntermediatePointClicked(): void {
    selectedIntermediatePoint = this.dataset.code;
    SelectedIntermediatePointChanged();
}

function CreateIntermediateDiv(text: string, code: string): HTMLDivElement {
    let div = document.createElement('div');
    div.innerText = text;
    div.dataset.code = code;
    div.onclick = IntermediatePointClicked;

    AddClass(div, 'clickable-div');
    AddClass(div, 'intermediate-point');
    AddClass(div, 'blue-header');
    if (code == selectedIntermediatePoint) {
        AddClass(div, 'selected');
    }
    return div;
}

function PrintIntermediatePoints(): void {
    let intermediatePointsContainer = document.getElementById('intermediate-points');
    intermediatePointsContainer.innerHTML = '';

    intermediatePointsContainer.appendChild(CreateIntermediateDiv(currentLanguage.race_startlist, START_CODE));

    const points = GetIntermediatePointsForClassId(selectedGroupId, selectedLegNumber);
    for (const point of points) {
        var textToPrint = point.text;
        if (AllClassesOrClubOrFavouritesIsSelected()) {
            textToPrint = point.code;
        }
        intermediatePointsContainer.appendChild(CreateIntermediateDiv(textToPrint, point.code));
    }

    intermediatePointsContainer.appendChild(CreateIntermediateDiv(currentLanguage.race_finish, FINISH_CODE));

    intermediatePointsContainer.appendChild(CreateIntermediateDiv(currentLanguage.race_combined_list, COMBINED_CODE));

    /*
     * Ensure that we have an intermediate point selected.
     */
    let intermediateExists = false;
    let intermediateElements = document.getElementById('intermediate-points').children;
    for (let i = 0; i < intermediateElements.length; ++i) {
        let element = intermediateElements[i] as HTMLElement;
        if (element.dataset.code == selectedIntermediatePoint) {
            intermediateExists = true;
            break;
        }
    }

    if (!intermediateExists && intermediateElements.length > 0) {
        selectedIntermediatePoint = (intermediateElements[0] as HTMLElement).dataset.code;
        SelectedIntermediatePointChanged();
    }
}

function CreateCombinedTimeAndPlaceColumnDefinition(pointName: string, title: string): Column<Runner> {
    return {
        'title': title,
        'data': null,
        'render': CombinedPlaceAndTimeRender,
        'name': pointName,
        'cssStyle': ['align-right', 'combined-time-column'],
        'sortType': ColumnTypeEnum.Number,
        'conditionalCellStyling': function (row: Runner): string[] {
            if (selectedGroupIsSprint) {
                return [];
            }

            if (!(pointName in row.times)) {
                // Runner does not have this intermediate time.
                return ['stripes'];
            }

            if (IsTimeRecentEvent(row.times[pointName], recentRowLimit)) {
                return ['recent-event'];
            }

            return [];
        }
    };
}

function PlaceRender(data: any, row: Runner, type: RenderTypeEnum) {
    let intermediatePointToUse = selectedIntermediatePoint;
    if (selectedGroupIsSprint) {
        intermediatePointToUse = FINISH_CODE;
    }
    if (type == RenderTypeEnum.Sort) {
        if (!(intermediatePointToUse in row.times)) {
            return Number.MAX_VALUE;
        }

        const time = row.times[intermediatePointToUse];
        if (time === null) {
            return Number.MAX_VALUE;
        }

        return GetSortNumberForPlace(row.status, row.times[intermediatePointToUse].place, row.not_competing);
    }

    return FormatPlace(row, intermediatePointToUse);
}

// TODO: Combine this with UsedTimeRender.
function UsedTimeLegRender(_: any, row: Runner, type: RenderTypeEnum) {
    if (!(selectedIntermediatePoint in row.times)) {
        return null;
    }

    const time = row.times[selectedIntermediatePoint];
    switch (row.status) {
        case RunnerStatus.DNF:
        case RunnerStatus.DNS:
            return null;
        default:
            if (type == RenderTypeEnum.Sort) {
                return time.used_time_leg;
            }

            return FormatMilliseconds(
                time.used_time_leg,
                selectedIntermediatePoint === FINISH_CODE,
                race.accuracy,
                false);
    }

}

function ShootingRender(_: any, row: Runner, _type: RenderTypeEnum) {
    if (!classLookup.has(row.class_id)) {
        return '';
    }

    const classObj = classLookup.get(row.class_id);
    const numShootings = NumShootingsInClass(classObj);

    return FormatShooting(row.shootings, numShootings);
}

function UsedTimeRender(_: any, row: Runner, type: RenderTypeEnum) {
    let intermediatePointToUse = selectedIntermediatePoint;
    if (selectedGroupIsSprint) {
        intermediatePointToUse = FINISH_CODE;
    }

    if (!(intermediatePointToUse in row.times)) {
        return null;
    }

    const time = row.times[intermediatePointToUse];
    switch (row.status) {
        case RunnerStatus.DNF:
        case RunnerStatus.DNS:
            return null;
        default:
            if (type == RenderTypeEnum.Sort) {
                return time.used_time;
            }
            return FormatMilliseconds(
                time.used_time,
                intermediatePointToUse === FINISH_CODE,
                race.accuracy,
                false);
    }

}

function DifferenceRender(_: any, row: Runner, type: RenderTypeEnum) {
    if (!(selectedIntermediatePoint in row.times)) {
        return null;
    }

    const time = row.times[selectedIntermediatePoint];
    switch (row.status) {
        case RunnerStatus.DNF:
        case RunnerStatus.DNS:
        case RunnerStatus.DSQ:
            return null;
        default:
            if (type == RenderTypeEnum.Sort) {
                return time.difference;
            }
            return FormatMilliseconds(
                time.difference,
                selectedIntermediatePoint === FINISH_CODE,
                race.accuracy,
                true);
    }
}

function PassingTimeRender(_: any, row: Runner, type: RenderTypeEnum) {
    if (!(selectedIntermediatePoint in row.times)) {
        return null;
    }

    const time = row.times[selectedIntermediatePoint];
    const passingTime = time.passing_time;
    if (passingTime === null) {
        return null;
    }

    if (type == RenderTypeEnum.Sort) {
        return Date.parse(passingTime);
    }

    return FormatDate(new Date(passingTime), 'HH:MM:SS');
}

function ClassIdIsFreeStart(class_id: string): boolean {
    if (!classLookup.has(class_id)) {
        return false;
    }

    const classObj = classLookup.get(class_id);
    if (!('free_start' in classObj)) {
        return false;
    }

    return classObj.free_start;
}

function StarttimeRender(_: any, data: Runner, type: RenderTypeEnum) {
    const free_start = ClassIdIsFreeStart(data.class_id);

    if (type == RenderTypeEnum.Sort) {
        if (free_start) {
            return Number.MAX_SAFE_INTEGER;
        }

        if (data.starttime === null || data.starttime.trim() == '') {
            return Number.MAX_SAFE_INTEGER;
        }

        return Date.parse(data.starttime);
    }

    if (free_start) {
        return currentLanguage.free_start;
    }

    if (data.starttime === null || data.starttime.trim() == '') {
        return '';
    }
    return FormatDate(new Date(data.starttime), 'HH:MM:SS');
}


function TimingChipsRender(data: number[], row: Runner, type: RenderTypeEnum) {
    if (type == RenderTypeEnum.Sort) {
        if (data === null || data.length == 0) {
            return Number.MIN_SAFE_INTEGER;
        }

        return data[0];
    }

    if (data == null) {
        return '';
    }

    let out = '';
    for (const timingChip of data) {
        if (out.length > 0) {
            out += ', ';
        }
        out += timingChip.toString();
    }
    return out;
}

function CombinedPlaceAndTimeRender(_: any, row: Runner, type: RenderTypeEnum, column: Column<Runner>) {
    let time = null;
    let code = column.name;

    if (code in row.times) {
        time = row.times[code];
    }

    if (type == RenderTypeEnum.Sort) {
        return CombinedListSort(selectedGroupId == null, row, time);
    }

    return FormatCombinedPlaceAndTime(row, code, race.accuracy, selectedGroupIsSprint);
}

function GetClass(classId: string): Class {
    if (classLookup.has(classId)) {
        return classLookup.get(classId);
    }

    return null;
}

function ClassIdIsRelay(classId: string): boolean {
    const classObj = GetClass(classId);
    if (classObj !== null) {
        return ClassIsRelay(classObj);
    }

    return false;
}

function ClassIsRelay(classObj: Class): boolean {
    return ('is_relay' in classObj) && classObj.is_relay;
}

function ClassIsPursuit(classObj: Class): boolean {
    return ('is_pursuit' in classObj) && classObj.is_pursuit;
}

function NumShootingsInClass(classObj: Class): number {
    if ('num_shootings' in classObj) {
        return classObj.num_shootings;
    }

    return 0;
}

function MaxNumShootings(): number {
    let max = 0;
    for (const classObj of classes) {
        max = Math.max(max, NumShootingsInClass(classObj));
    }
    return max;
}

function AnyClassIsRelay(): boolean {
    for (const classObj of classes) {
        if (ClassIsRelay(classObj)) {
            return true;
        }
    }

    return false;
}

function AnyClassIsPursuit(): boolean {
    for (const classObj of classes) {
        if (ClassIsPursuit(classObj)) {
            return true;
        }
    }

    return false;
}

function SetTableSearch() {
    let filters: ((runner: Runner) => boolean)[] = [];
    if (selectedGroupId !== null) {
        if (leftMenu === LEFT_MENU_CLASSES) {
            filters.push(function (runner: Runner): boolean {
                return runner.class_id == selectedGroupId;
            });
        } else if (leftMenu === LEFT_MENU_CLUBS) {
            filters.push(function (runner: Runner): boolean {
                return runner.club_name == selectedGroupId;
            });
        }
    }

    if (leftMenu === LEFT_MENU_FAVOURITES) {
        filters.push(function (runner: Runner): boolean {
            return runner.favourite;
        });
    }

    if (selectedIntermediatePoint !== START_CODE && selectedIntermediatePoint !== COMBINED_CODE) {
        if (selectedIntermediatePoint === FINISH_CODE) {
            filters.push(function (runner: Runner): boolean {
                switch (runner.status) {
                    case RunnerStatus.DNF:
                    case RunnerStatus.OK:
                    case RunnerStatus.DSQ: case RunnerStatus.DNS:
                    case RunnerStatus.NC:
                        return true;
                    default:
                        return false;
                }

            });
        } else {
            filters.push(function (runner: Runner): boolean {
                let intermediatePointToUse = selectedIntermediatePoint;
                if (selectedGroupIsSprint) {
                    intermediatePointToUse = FINISH_CODE;
                }

                const formattedPlace = FormatPlace(runner, intermediatePointToUse);
                return formattedPlace.length > 0;
            });
        }
    }

    if (selectedLegNumber !== null && !ShowAllLegs()) {
        filters.push(function (runner: Runner): boolean {
            return runner.leg_number == selectedLegNumber;
        });
    }


    datatables.mainTable.setFilter(function (runner: Runner): boolean {
        for (const filter of filters) {
            if (!filter(runner)) {
                return false;
            }
        }

        return true;
    })
}

function GetColumnIndex(columnName: string): number {
    for (let i = 0; i < columns.length; ++i) {
        if (('name' in columns[i]) && columns[i].name == columnName) {
            return i;
        }
    }

    return -1;
}

function GatherDistinctIntermediatePoints(legNumber: number): IntermediatePoint[] {
    if (legNumber === null) {
        legNumber = 1;
    }

    var seenPoints = new Set<string>();
    var returnValue: IntermediatePoint[] = [];
    for (const point of intermediatePoints) {
        if (point.leg_number != legNumber) {
            continue;
        }

        if (seenPoints.has(point.code)) {
            continue;
        }

        seenPoints.add(point.code);
        returnValue.push(point);
    }

    return returnValue;
}

function GetIntermediatePointsForClassId(classId: string, legNumber: number): IntermediatePoint[] {
    if (leftMenu === LEFT_MENU_CLUBS || leftMenu === LEFT_MENU_FAVOURITES || classId === null) {
        return GatherDistinctIntermediatePoints(legNumber);
    }

    if (legNumber === null) {
        legNumber = 1;
    }

    var returnValue = [];
    for (const point of intermediatePoints) {
        if (point.class_id == classId && point.leg_number == legNumber) {
            returnValue.push(point);
        }
    }

    return returnValue;
}

let resultLookup: ResultLookup = {
    classes: {}
};

function RebuildIntermediatePointsPerClass(): void {
    intermediatePointsPerClass.clear();
    for (const classObj of classes) {
        intermediatePointsPerClass.set(classObj.class_id, []);
    }

    for (const intermediatePoint of intermediatePoints) {
        if (!intermediatePointsPerClass.has(intermediatePoint.class_id)) {
            intermediatePointsPerClass.set(intermediatePoint.class_id, []);
        }

        intermediatePointsPerClass.get(intermediatePoint.class_id).push(intermediatePoint);
    }
}

function StartListeners() {
    webSocket = new NewWebsocket(raceId, ['runners', 'classes', 'races', 'messages', 'intermediate_points'], true);
    webSocket.DataReceived = function (collectionName, data, fullReload, idFieldsFromManifest) {

        switch (collectionName) {
            case 'runners':
                HandleRunnersChanged(data, fullReload);
                break;
            case 'classes':
                HandleClassesChanged(data, fullReload, idFieldsFromManifest);
                break;
            case 'messages':
                HandleMessagesChanged(data, fullReload, idFieldsFromManifest);
                break;
            case 'races':
                RaceChanged(data);
                break;
            case 'intermediate_points':
                HandleIntermediatePointsChanged(data, fullReload, idFieldsFromManifest);
                break;
        }

        firstLoad = false;
    }
}

function HandleIntermediatePointsChanged(changes: NewChanges<IntermediatePoint>, allData: boolean, idFieldsFromManifest: string[]): void {
    const hasAnyChange = HandleChangesNew(
        allData,
        changes,
        intermediatePoints,
        (a) => {
            if (!('leg_number' in a)) {
                a.leg_number = 1;
            }
        },
        idFieldsFromManifest);

    if (hasAnyChange) {
        intermediatePoints.sort(function (a, b) {
            return a.sort_order - b.sort_order;
        });

        RebuildIntermediatePointsPerClass();

        EnsureAllIntermediatePointsArePresent(
            datatables.mainTable.data(),
            intermediatePoints
        );

        /*
         * Lets us re-create the datatable to ensure that any changes to
         * intermediate points becomes visible.
         */
        ReCreateDataTable();
        SelectedGroupChanged();
    }
}

function HandleMessagesChanged(changes: NewChanges<Message>, allData: boolean, idFieldsFromManifest: string[]): void {
    if (allData) {
        messages = [];
    }

    const hasAnyChanges = HandleChangesNew(
        allData,
        changes,
        messages,
        () => { },
        idFieldsFromManifest
    );

    if (hasAnyChanges) {
        messages.sort(function (a, b) { return Date.parse(b.time_of_message) - Date.parse(a.time_of_message); });

        let messagesChildren = document.getElementById('messages-children');
        messagesChildren.innerHTML = '';
        for (let i = 0; i < 3 && i < messages.length; ++i) {
            const message = messages[i];
            let td = document.createElement('td');
            td.innerText = FormatDate(new Date(message.time_of_message), 'HH:MM:SS') + ' - ' + message.message;

            let tr = document.createElement('tr');
            tr.appendChild(td);
            messagesChildren.appendChild(tr);
        }
    }
}

function HandleClassesChanged(changes: NewChanges<Class>, allData: boolean, idFieldsFromManifest: string[]): void {
    const hasAnyChange = HandleChangesNew(
        allData,
        changes,
        classes,
        () => { },
        idFieldsFromManifest
    );


    if (hasAnyChange) {
        classes.sort((a, b) => {
            if (a.sort_order == b.sort_order) {
                return a.name.localeCompare(b.name);
            }

            return a.sort_order - b.sort_order
        });

        RebuildClassLookup();
        RebuildIntermediatePointsPerClass();
        RebuildResultLookup();

        if (firstLoad) {
            for (const classObj of classes) {
                if (IsSprintClass(classObj) && ('parent_class_id' in classObj) && classObj.parent_class_id == null) {
                    selectedGroupId = classObj.class_id + '-prolog';
                    break;
                } else if (!IsSprintClass(classObj)) {
                    selectedGroupId = classObj.class_id;
                    break;
                }
            }
        }

        PrintLeftMenu();

        SelectedGroupChanged();

    }
}

function CreateGroupDiv(text: string, groupId: string, allClasses: boolean, sprintFinals: boolean): HTMLDivElement {
    let div = document.createElement('div');

    div.dataset.classId = groupId;
    div.dataset.allClasses = allClasses ? '1' : '0';
    div.dataset.sprintFinals = sprintFinals ? '1' : '0';
    div.innerText = text;
    AddClass(div, 'clickable-div');
    AddClass(div, 'class-element');
    AddClass(div, 'blue-child');
    div.onclick = LeftMenuClicked;

    if (allClasses) {
        div.dataset.i18n = 'race_all_classes';
    }
    return div;
}

function GetDistinctClubs(): string[] {
    let addedClubs = new Set<string>()
    let output: string[] = [];

    const runners = datatables.mainTable.data();
    for (const runner of runners) {
        if (runner.club_name === null || runner.club_name.trim() == '') {
            continue;
        }

        if (!addedClubs.has(runner.club_name)) {
            addedClubs.add(runner.club_name);
            output.push(runner.club_name);
        }
    }

    return output;
}

function SetLeftMenuClasses(): void {
    leftMenu = LEFT_MENU_CLASSES;
    PrintLeftMenu();
    SelectedGroupChanged();
}


function SetLeftMenuClubs(): void {
    leftMenu = LEFT_MENU_CLUBS;
    PrintLeftMenu();
    SelectedGroupChanged();
}

function SetLeftMenuFavourites(): void {
    leftMenu = LEFT_MENU_FAVOURITES;
    selectedGroupId = null;
    PrintLeftMenu();
}

function ExportExcel(): void {
    datatables.mainTable.export('Liveresultater export.xlsx');
}

function IsSprintClass(classObj: Class): boolean {
    return ('sprint_total_number_of_rounds' in classObj) && classObj.sprint_total_number_of_rounds != null;
}

function PrintLeftMenu(): void {
    if (leftMenu === LEFT_MENU_CLUBS) {
        RemoveClass(document.getElementById('left-menu-classes'), 'selected');
        RemoveClass(document.getElementById('left-menu-favourites'), 'selected');
        AddClass(document.getElementById('left-menu-clubs'), 'selected');
    } else if (leftMenu === LEFT_MENU_CLASSES) {
        AddClass(document.getElementById('left-menu-classes'), 'selected');
        RemoveClass(document.getElementById('left-menu-favourites'), 'selected');
        RemoveClass(document.getElementById('left-menu-clubs'), 'selected');
    } else if (leftMenu === LEFT_MENU_FAVOURITES) {
        RemoveClass(document.getElementById('left-menu-classes'), 'selected');
        RemoveClass(document.getElementById('left-menu-clubs'), 'selected');
        AddClass(document.getElementById('left-menu-favourites'), 'selected');
    }

    let classesBody = document.getElementById('classes-children');
    classesBody.innerHTML = '';

    if (leftMenu === LEFT_MENU_CLASSES) {
        for (const classObj of classes) {
            if (IsSprintClass(classObj)) {
                // Print out sprint classes. That is, find the "parent" classes and print out
                // "classname prolog" and "classname finaler"
                if (('parent_class_id' in classObj) && classObj.parent_class_id == null) {
                    classesBody.appendChild(CreateGroupDiv(classObj.name + ' ' + currentLanguage.race_sprint_prolog_suffix, classObj.class_id + "-prolog", false, false));
                    classesBody.appendChild(CreateGroupDiv(classObj.name + ' ' + currentLanguage.race_sprint_finals_suffix, classObj.class_id, false, true));
                }
            } else {
                classesBody.appendChild(CreateGroupDiv(classObj.name, classObj.class_id, false, false));
            }
        }

        classesBody.appendChild(CreateGroupDiv(currentLanguage.race_all_classes, '', true, false));
    } else if (leftMenu === LEFT_MENU_CLUBS) {
        let clubs = GetDistinctClubs();
        clubs.sort((a, b) => {
            return a.localeCompare(b);
        });

        for (const club of clubs) {
            classesBody.appendChild(CreateGroupDiv(club, club, false, false));
        }
    } else if (leftMenu === LEFT_MENU_FAVOURITES) {
        SelectedGroupChanged();
        return;
    }

    MarkSelectedGroup(true);
}

function LeftMenuClicked(): void {
    if (this.dataset.allClasses == '1') {
        selectedGroupId = null;
    } else {
        selectedGroupId = this.dataset.classId;
    }

    SelectedGroupChanged();
}

function MarkSelectedGroup(chooseNewIfCurrentIsInvalid: boolean): void {
    const classesElements = document.getElementById('classes-children').children;
    let wasAnySelected = false;
    for (let i = 0; i < classesElements.length; ++i) {
        const element = classesElements[i] as HTMLElement;
        if (element.dataset.classId == selectedGroupId ||
            (selectedGroupId === null && element.dataset.allClasses == '1')) {
            AddClass(element, 'selected');
            wasAnySelected = true;
            selectedGroupIsSprint = element.dataset.sprintFinals == '1';
        } else {
            RemoveClass(element, 'selected');
        }
    }

    if (!wasAnySelected && chooseNewIfCurrentIsInvalid) {
        // Ensure that we have a valid group id selected
        for (let i = 0; i < classesElements.length; ++i) {
            const element = classesElements[i] as HTMLElement;
            if (element.dataset.allClasses == '1') {
                selectedGroupId = null;
            } else {
                selectedGroupId = element.dataset.classId;
            }
            break;
        }
    }
}

function SelectedGroupChanged(): void {
    if (leftMenu != LEFT_MENU_FAVOURITES) {
        // Favourites don't have a group to select.
        MarkSelectedGroup(true);
    }

    PrintIntermediatePoints();

    let legsContainer = document.getElementById('legs-container');
    if ((AllClassesOrClubOrFavouritesIsSelected() && AnyClassIsRelay()) || ClassIdIsRelay(selectedGroupId)) {
        if (selectedLegNumber === null) {
            selectedLegNumber = 1;
        }
        PrintLegs();
        RemoveClass(legsContainer, 'hidden');
    } else {
        selectedLegNumber = null;
        AddClass(legsContainer, 'hidden');
    }

    ReCreateDataTable();
    PrintTableHeading();
}

function GetMaxNumberOfLegs(): number {
    let maxLegs = 0;
    for (const classObj of classes) {
        if (ClassIsRelay(classObj)) {
            maxLegs = Math.max(maxLegs, classObj.num_legs);
        }
    }

    return maxLegs;
}

function SelectedLegChanged(redrawTable: boolean): void {
    let legRowElements = document.getElementById('legs-children').children;

    for (let j = 0; j < legRowElements.length; ++j) {
        let legsElements = legRowElements[j].children;
        for (let i = 0; i < legsElements.length; ++i) {
            let element = legsElements[i] as HTMLElement;
            if (Number.parseInt(element.dataset.leg) == selectedLegNumber) {
                AddClass(element, 'selected');
            } else {
                RemoveClass(element, 'selected');
            }
        }
    }

    if (redrawTable) {
        ReCreateDataTable();
    }

    PrintTableHeading();

    PrintIntermediatePoints();
}

function GetIntermediatePoint(classId: string, legNumber: number, code: string): IntermediatePoint {
    const intermediatePoinstForClass = GetIntermediatePointsForClassId(classId, legNumber);
    for (let i = 0; i < intermediatePoinstForClass.length; ++i) {
        // NOTE: Important to not use '===' here, as we may be comparing string and number.
        if (intermediatePoinstForClass[i].code == code) {
            return intermediatePoinstForClass[i];
        }
    }

    return null;
}

function PrintTableHeading(): void {
    let text: string = '';
    if (leftMenu === LEFT_MENU_CLUBS) {
        text = selectedGroupId;
    } else if (leftMenu === LEFT_MENU_CLASSES) {
        if (selectedGroupId === null) {
            text = currentLanguage.race_all_classes_table_heading;
        } else {
            const selectedClass = GetClass(selectedGroupId);
            if (selectedClass !== null) {
                text = selectedClass.name;
            } else {
                text = currentLanguage.race_unknown_class_table_heading;
            }
        }
    } else if (leftMenu === LEFT_MENU_FAVOURITES) {
        text = currentLanguage.race_favourites_table_heading;
    }

    if (selectedLegNumber !== null) {
        if (selectedLegNumber === ALL_LEGS) {
            text = text + ', ' + currentLanguage.race_all_legs_table_heading;
        } else {
            text = text + ', ' + currentLanguage.race_leg_table_heading + ' ' + selectedLegNumber;
        }
    }

    if (selectedIntermediatePoint === START_CODE) {
        text = text + ', ' + currentLanguage.race_startlist_table_heading;
    } else if (selectedIntermediatePoint === FINISH_CODE) {
        text = text + ', ' + currentLanguage.race_finish_table_heading;
    } else if (selectedIntermediatePoint === COMBINED_CODE) {
        text = text + ', ' + currentLanguage.race_combined_list_table_heading;
    } else {
        if (AllClassesOrClubOrFavouritesIsSelected()) {
            text = text + ', ' + currentLanguage.race_intermediate_code_table_heading + ' ' + selectedIntermediatePoint;
        } else {
            const intermediatePoint = GetIntermediatePoint(selectedGroupId, selectedLegNumber, selectedIntermediatePoint);
            if (intermediatePoint !== null) {
                text = text + ', ' + intermediatePoint.text;
            }
        }
    }

    const tableHeading = document.getElementById('table-heading');
    tableHeading.innerText = text;
}

function PrintRunnerStatistics(): void {
    let text = '';

    let numRunners = 0;
    datatables.mainTable.forEach(function () {
        ++numRunners;
    }, ForEachFilter.AllFiltered);

    if (numRunners === 1) {
        text = currentLanguage.race_stats_one_runner;
    } else {
        text = numRunners + ' ' + currentLanguage.race_stats_multiple_runners;
    }

    if (leftMenu === LEFT_MENU_CLASSES && (selectedIntermediatePoint === FINISH_CODE || selectedIntermediatePoint === COMBINED_CODE)) {
        let count = 0;
        for (const runner of datatables.mainTable.data()) {
            if (selectedGroupId !== null && runner.class_id != selectedGroupId) {
                continue;
            }

            if (runner.status == RunnerStatus.REGISTERED) {
                ++count;
            }
        }
        const remainingRunners: number = datatables.mainTable
            .data()
            .filter(function (value: Runner, _index) {
                if (selectedGroupId !== null && value.class_id != selectedGroupId) {
                    return false;
                }
                return value.status == RunnerStatus.REGISTERED ? true : false;
            }).length;

        text = text + ', ' + remainingRunners + ' ' + currentLanguage.race_stats_runners_remaining;
    }

    const element = document.getElementById('runner-stats');
    element.innerText = text;
}

function ShowAllLegs(): boolean {
    return selectedLegNumber == ALL_LEGS;
}

function LegClicked(): void {
    selectedLegNumber = Number.parseInt(this.dataset.leg);
    SelectedLegChanged(true);
}

function AllClassesOrClubOrFavouritesIsSelected(): boolean {
    return selectedGroupId === null || leftMenu === LEFT_MENU_CLUBS || leftMenu === LEFT_MENU_FAVOURITES;
}

function PrintLegs(): void {
    let legsChildren = document.getElementById('legs-children');
    legsChildren.innerHTML = '';

    let numLegs = 0;
    if (AllClassesOrClubOrFavouritesIsSelected()) {
        numLegs = GetMaxNumberOfLegs();
    } else {
        const classObj = GetClass(selectedGroupId);
        if (classObj != null) {
            numLegs = classObj.num_legs;
        }
    }

    // Add one leg for "Alle"
    numLegs++;

    const LEGS_PER_ROW = 4;
    let currentRow = document.createElement('div');
    AddClass(currentRow, 'legs-row');
    for (let i = 0; i < numLegs; ++i) {
        let leg = document.createElement('div');

        if (i + 1 == numLegs) {
            leg.dataset.leg = ALL_LEGS.toString();
            leg.innerText = currentLanguage.race_all_legs;
        } else {
            leg.dataset.leg = (i + 1).toString();
            leg.innerText = (i + 1).toString();
        }

        AddClass(leg, 'leg');
        AddClass(leg, 'clickable-div');
        AddClass(leg, 'blue-child');
        leg.onclick = LegClicked;

        currentRow.appendChild(leg);

        if (i + 1 % LEGS_PER_ROW == 0 || i == numLegs - 1) {
            legsChildren.appendChild(currentRow);

            currentRow = document.createElement('div');
            AddClass(currentRow, 'legs-row');
        }
    }

    SelectedLegChanged(false);
}

function MarkFavourites(settings: PageSettings, runners: Runner[]): void {
    for (let runner of runners) {
        if (runner.runner_id in settings.favourites) {
            runner.favourite = true;
        } else {
            runner.favourite = false;
        }
    }
}

function SortTimingChips(runners: Runner[]): void {
    for (const runner of runners) {
        if (runner.timing_chips != null) {
            runner.timing_chips.sort((a: number, b: number): number => {
                return a - b;
            });
        }
    }
}

function HandleRunnersChanged(changes: NewChanges<Runner>, allData: boolean): void {
    if (changes == null) {
        return;
    }

    let settings = LoadSettings();
    let hasAnyChange: boolean = false;
    if (allData) {
        datatables.mainTable.clear();
        for (const table of datatables.sprintTables) {
            table.clear();
        }
    }

    if (changes.delete.length > 0) {
        hasAnyChange = true;
        let toDelete: number[] = [];
        for (const ids of changes.delete) {
            toDelete.push(ids[0]);
        }

        datatables.mainTable.deleteRows(toDelete);
        for (const table of datatables.sprintTables) {
            table.deleteRows(toDelete);
        }
    }

    if (changes.upsert.length > 0) {
        hasAnyChange = true;
        SortTimingChips(changes.upsert);
        MarkFavourites(settings, changes.upsert);
        EnsureAllIntermediatePointsArePresent(
            changes.upsert,
            intermediatePoints
        );


        datatables.mainTable.upsertRows(changes.upsert);
        for (const table of datatables.sprintTables) {
            table.upsertRows(changes.upsert);
        }
    }

    if (hasAnyChange) {
        RebuildResultLookup();

        CalculateRunningTimeForAll();

        datatables.mainTable.newDraw();
        for (const table of datatables.sprintTables) {
            table.newDraw();
        }
        PrintRunnerStatistics();
    }

    if (leftMenu === LEFT_MENU_CLUBS) {
        PrintLeftMenu();
    }
}

function RaceChanged(changes: NewChanges<RaceInfo>): void {
    let change: RaceInfo;
    if (changes.upsert != null && changes.upsert.length > 0) {
        change = changes.upsert[0];
    } else {
        return;
    }

    const forceDraw = race !== null && race.accuracy != change.accuracy;
    race = change;
    let descriptionElement = document.getElementById('race_description');
    let organizerElement = document.getElementById('race_organizer');
    let dateElement = document.getElementById('race_date');

    if ('description' in race) {
        descriptionElement.innerText = race.description;
    }

    if ('organizer' in race) {
        organizerElement.innerText = race.organizer;
    }

    if (!IsNullOrWhitespace(race.date)) {
        dateElement.innerText = FormatDate(new Date(race.date), 'dd.mm.yyyy');
    }

    if (forceDraw) {
        datatables.mainTable.newDraw();

        for (const table of datatables.sprintTables) {
            table.newDraw();
        }
    }
}

function IsTimeRecentEvent(time: Time, limit: number): boolean {
    if (time === null) {
        return false;
    }

    if (!('passing_time' in time)) {
        return false;
    }

    return limit < Date.parse(time.passing_time);
}

// This and below functions are around 3-4x faster than doing
// classList.add/remove unconditionally. This is microoptimization,
// but it is used in some tight loops.
function ClassNameContainsClass(elementClassName: string, className: string): boolean {
    const index = elementClassName.indexOf(className);
    if (index == -1) {
        return false;
    }

    // The below length and whitespace checks are to avoid false positives for
    // cases where i.e., elementClassName == "foobar" and className == "foo".
    if (className.length == elementClassName.length) {
        return true;
    }

    if (index == 0) {
        return elementClassName[className.length] == ' ';
    }

    return elementClassName[index - 1] == ' ';
}

function RemoveClass(htmlElement: Element, className: string): void {
    if (ClassNameContainsClass(htmlElement.className, className)) {
        htmlElement.classList.remove(className);
    }
}

function AddClass(htmlElement: Element, className: string): void {
    if (!ClassNameContainsClass(htmlElement.className, className)) {
        htmlElement.classList.add(className);
    }
}

let recentRowLimit = GetMarkRecentRowLimit();
function GetMarkRecentRowLimit(): number {
    return Date.now() - (60 * 1000);
}

function CalculateRunningTimeTimer(): void {
    recentRowLimit = GetMarkRecentRowLimit();
    CalculateRunningTimeForAll();
    datatables.mainTable.newDraw();

    setTimeout(CalculateRunningTimeTimer, 1000 - new Date().getMilliseconds());
}

function CalculateRunningTimeForAll(): void {
    let now = Date.now();
    let relayTeamsStarttime: RelayTeamsStarttime = {};

    const runners = datatables.mainTable.data();
    for (const runner of runners) {
        if (runner.relay_team !== null && runner.leg_number == 1) {
            relayTeamsStarttime[runner.bib] = runner.starttime;
        }
    }

    for (const runner of runners) {
        let intermediatePoints = [];
        if (intermediatePointsPerClass.has(runner.class_id)) {
            intermediatePoints = intermediatePointsPerClass.get(runner.class_id);
        }

        if (!classLookup.has(runner.class_id)) {
            return;
        }

        CalculateRunningTime(
            runner,
            now,
            intermediatePoints,
            relayTeamsStarttime,
            resultLookup,
            classLookup.get(runner.class_id));
    }
}

function RebuildResultLookup(): void {
    resultLookup = CreateResultLookup(
        classes,
        datatables.mainTable.data()
    );
}

let classLookup = new Map<string, Class>();
function RebuildClassLookup(): void {
    classLookup = new Map();
    for (const classObj of classes) {
        classLookup.set(classObj.class_id, classObj);
    }
}